"use strict";

exports.__esModule = true;
exports.dataHooks = void 0;
var dataHooks = exports.dataHooks = {
  tickerUp: 'ticker-up-button',
  tickerDown: 'ticker-down-button'
};
//# sourceMappingURL=constants.js.map